module.exports = "531a72d96114401c44bcfb8710a483d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/lantern-edge-L.png
// module id = 55
// module chunks = 0